import React from 'react'
import Header from '../Component/Header'
import { Link } from 'react-router-dom'
import Footer from '../Component/Footer'
import LazyLoad from 'react-lazyload';
import { useEffect } from 'react'
const CBSEMandatory = () => {
  useEffect(() => {
    // Set the page title
    document.title = 'CBSE Mandatory Disclosure - Presentation Convent School Delhi';
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li><Link to="/"> Home</Link> </li>
          <li> School</li>
          <li>  CBSE Mandatory Disclosure</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> CBSE Mandatory Disclosure</h1>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p><b>A: GENERAL INFORMATION</b></p>
              <div class="table-responsive booklist innertable">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">S. No.</th>
                      <th class="text-center">INFORMATION</th>
                      <th class="text-center">DETAILS</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr>
                      <td>1</td>
                      <td>NAME OF THE SCHOOL</td>
                      <td>PRESENTATION CONVENT SR SEC SCHOOL</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>AFFILIATION NO.(IF APPLICABLE)</td>
                      <td>2730061</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>SCHOOL CODE (IF APPLICABLE)</td>
                      <td>85058</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>COMPLETE ADDRESS WITH PIN CODE</td>
                      <td>S P MUKHERJI MARG DELHI, NORTH DELHI , DELHI - 110006</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>PRINCIPAL NAME &amp; QUALIFICATION</td>
                      <td>SISTER REGI JOSEPH, M.A. B.Ed.</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>SCHOOL EMAIL ID</td>
                      <td><a href="mailto:mail@pcsdelhi.in">mail@pcsdelhi.in</a></td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>CONTACT DETAILS (LANDLINE/MOBILE)</td>
                      <td><a href="tel:9868969747">9868969747</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="clr20"></div>
              <p><b>B: DOCUMENTS AND INFORMATION</b></p>
              <div class="table-responsive booklist innertable">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">S. No.</th>
                      <th class="text-center">DOCUMENTS/INFORMATION</th>
                      <th class="text-center">UPLOAD DOCUMENTS</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr>
                      <td>1</td>
                      <td>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY</td>
                      <td><a href="https://webapi.entab.info/api/image/PCSD/public/pdf/Affiliation-Letter.pdf" target="_blank">View</a></td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE</td>
                      <td><a href="https://webapi.entab.info/api/image/PCSD/public/pdf/Society-Registration.pdf" target="_blank">View </a></td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY THE STATE GOVT./UT</td>
                      <td><a href="#" target="_blank">View </a></td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009, AND IT’S RENEWAL IF APPLICABLE</td>
                      <td><a href="https://webapi.entab.info/api/image/PCSD/public/pdf/School-Recognition-Certificate.pdf" target="_blank">View</a></td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE</td>
                      <td><a href="https://webapi.entab.info/api/image/PCSD/public/pdf/Building-Safety-Certificate.pdf" target="_blank">View</a></td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY</td>
                      <td><a href="https://webapi.entab.info/api/image/PCSD/public/pdf/Fire-Safety-Certificate.pdf" target="_blank">View</a></td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFILIATION/UPGRADATION/EXTENSION OF AFFILIATIONOR SELF CERTIFICATION BY SCHOOL</td>
                      <td><a href="https://webapi.entab.info/api/image/PCSD/public/pdf/Self-Decleration.pdf" target="_blank">View </a></td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES </td>
                      <td><a href="https://webapi.entab.info/api/image/PCSD/public/pdf/Water,-Health-and-Sanitation-Certificates.pdf" target="_blank">View</a></td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>MANDATORY DISCLOSURE</td>
                      <td><a href="https://webapi.entab.info/api/image/PCSD/public/pdf/General-Information.pdf" target="_blank">View</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="clr20"></div>
              <p><b>C: RESULT AND ACADEMICS</b></p>
              <div class="table-responsive booklist innertable">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">S. No.</th>
                      <th class="text-center">DOCUMENTS/INFORMATION</th>
                      <th class="text-center">UPLOAD DOCUMENTS</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr>
                      <td>1</td>
                      <td>FEE STRUCTURE OF THE SCHOOL</td>
                      <td><a href="https://www.pcsdelhi.in/SchoolFees" target="_blank">View </a></td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>ANNUAL ACADEMIC CALANDER</td>
                      <td><a href="https://webapi.entab.info/api/image/PCSD/public/pdf/Activity-Calendar.pdf" target="_blank">View</a></td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)</td>
                      <td><a href="https://www.pcsdelhi.in/SMCMembers" target="_blank">View</a></td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS</td>
                      <td><a href="https://www.pcsdelhi.in/PTAMember" target="_blank">View</a></td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABLILITY</td>
                      <td><a href="https://www.pcsdelhi.in/CbseResultAnalysis" target="_blank">View</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="clr20"></div>
              <p><b>D: STAFF (TEACHING)</b></p>
              <div class="table-responsive booklist innertable">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">S. No.</th>
                      <th class="text-center">INFORMATION</th>
                      <th class="text-center">DETAILS</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr>
                      <td>1</td>
                      <td>PRINCIPAL</td>
                      <td>SISTER REGI JOSEPH</td>
                    </tr>
                    <tr>
                      <td rowspan="4">2</td>
                      <td>TOTAL NO. OF TEACHERS</td>
                      <td>82</td>
                    </tr>
                    <tr> 
                      <td>o PGT</td>
                      <td>13</td>
                    </tr>
                    <tr>
                      <td>o TGT</td>
                      <td>29</td>
                    </tr>
                    <tr>
                      <td>o PRT</td>
                      <td>39</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>TEACHERS SECTION RATIO</td>
                      <td>1:1.5</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>DETAILS OF SPECIAL EDUCATOR</td>
                      <td>Ms. Avnita Joshi</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>DETAILS OF COUNSELLOR AND WELNESS TEACHER</td>
                      <td>Ms. Varnika Chauhan, Ms. Mini Manoj</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="clr20"></div>
              <p><b>E: SCHOOL INFRASTRUCTURE</b></p>
              <div class="table-responsive booklist innertable">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">S. No.</th>
                      <th class="text-center">INFORMATION</th>
                      <th class="text-center">DETAILS</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr>
                      <td>1</td>
                      <td>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)</td>
                      <td>16363</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>NO. AND SIZE OF THE CLASS ROOMS (IN SQUARE MTR)</td>
                      <td>52 & 57</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (IN SQ MTR)</td>
                      <td>7 & 129</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>INTERNET FACILITY (Y/N)</td>
                      <td>YES</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>NO. OF GIRLS TOILETS</td>
                      <td>97</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>NO. OF BOYS TOILETS</td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE INFRASTRUCTURE OF THE SCHOOL</td>
                      <td><a href="https://www.youtube.com/watch?v=Xu4gxovyDEk&feature=youtu.be" target="_blank">https://www.youtube.com/watch?v=Xu4gxovyDEk&feature=youtu.be</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default CBSEMandatory